import React, {useEffect, useState} from "react";
import {useGoogleReCaptcha} from 'react-google-recaptcha-v3';
import {Col, Container, Form, FormGroup, Row, Spinner} from 'react-bootstrap';
import {useSearchParams} from "react-router-dom";
import {useCookies} from 'react-cookie';
import regobg from '../images/rego_background.png';
import ContinueOfflinePopupTFAF2 from "./ContinueOfflinePopupTFAF2";
import ContinueOfflinePopupProspectFailed from "./ContinueOfflinePopupProspectFailed";
import TooltipTFAF from "./common/TooltipTFAF";
import Cookies from "js-cookie";
import {useLocation} from "react-use";
import _ from 'lodash';
import NavigateMBI from "./NavigateMBI";
import moment from "moment/moment";
import NavigateAAMBI from "./NavigateAAMBI";
import {BlackCarIcon, MidBlueCarIcon} from "./common/TfafCommonComponent";
import WelcomeBackQuote from "./WelcomeBackQuote";
import {useFeature} from '../hooks/useFeature';

const CarDetailsTFAF = props => {
  const {executeRecaptcha} = useGoogleReCaptcha();
  const scrollToTop = () => window.scrollTo(0, 0);
  const [continueOfflinePopupShow, setContinueOfflinePopupShow] = useState(false);
  const [continueOfflinePopupProspectFailed, setContinueOfflinePopupProspectFailed] = useState(false);
  const [vehicleData, setVehicleData] = useState();
  const [quoteData, setQuoteData] = useState();
  const [vehicleDataPresent, setVehicleDataPresent] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [cookie, setCookie] = useCookies(['jwt-token'])
  const [source, setSource] = useState();
  const [urlSource, setURLSource] = useState();
  let url = process.env.REACT_APP_MODE !== null && process.env.REACT_APP_MODE !== undefined && process.env.REACT_APP_MODE.includes('dev') ? 'http://localhost:8080/edge' : '/edge';
  const [errorMessage, setErrorMessage] = useState('');
  const [selectedExclusions, setSelectedExclusions] = useState([]);
  const [errors, setErrors] = useState({});
  const [isFocused, setIsFocused] = useState(false);
  const [registrationNumber, setRegistrationNumber] = useState('');
  const nztaUnavailable = useFeature('nztaUnavaiable');
  const apiUrl = process.env.REACT_APP_MODE?.includes('dev') ? 'http://localhost:8080/edge' : '/edge';
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [additionalBenefit, setAdditionalBenefit] = useState(new Map());
  const [returnUser, setReturnUser] = useState(false);
  const [quoteNum, setQuoteNum] = useState('');
  const location = useLocation();
  const [nextButtonDisabled, setNextButtonDisabled] = useState(false);
  const isAAPath = props.inputValues.source === 'AA' || props.inputValues.source === 'AA_MEMBER';
  const isVTNZPath = props.inputValues.source === 'VTNZ';
  const baseUrl = window.location.origin;

  const handleNewQuoteClick = () => {
    window.location.href = '/mbi';
  };

  const updateAB = (k, v) => {
    setAdditionalBenefit(additionalBenefit.set(k, v));
  }


  const handleRegistrationNumberChange = (e) => {
    setNextButtonDisabled(false);
    setVehicleData(null);
    setVehicleDataPresent(false);
    // Remove all spaces from the input value
    const valueWithoutSpaces = e.target.value.replace(/\s/g, '');
    setRegistrationNumber(valueWithoutSpaces);
    props.handleChangeValue("registration", valueWithoutSpaces);
    // Update the input field value to reflect the change
    e.target.value = valueWithoutSpaces;
  };
  const handlePropulsionChange = (option) => {
    let updatedOptions = [...props.inputValues.propulsionOptions];

    if (option === 'None of the above') {
      // If "None of the above" is selected, unselect all other options
      updatedOptions = [];
    } else if (option === 'ELECTRIC' || option === 'HYBRID') {
      // If Electric or Hybrid is selected, ensure the other is unselected
      const otherOption = option === 'ELECTRIC' ? 'HYBRID' : 'ELECTRIC';
      if (updatedOptions.includes(otherOption)) {
        updatedOptions = updatedOptions.filter(o => o !== otherOption);
      }
      // If "None of the above" is selected, unselect it
      const noneOptionIndex = updatedOptions.indexOf('None of the above');
      if (noneOptionIndex !== -1) {
        updatedOptions.splice(noneOptionIndex, 1);
      }
    } else {
      // If any other option is selected, check if "None of the above" is selected and unselect it
      const noneOptionIndex = updatedOptions.indexOf('None of the above');
      if (noneOptionIndex !== -1) {
        updatedOptions.splice(noneOptionIndex, 1);
      }
    }

    // Toggle the selected option
    const optionIndex = updatedOptions.indexOf(option);
    if (optionIndex !== -1) {
      updatedOptions.splice(optionIndex, 1);
    } else {
      updatedOptions.push(option);
    }

    props.handleChangeValue("propulsionOptions", updatedOptions);
  };
  const camelize = (str) => {
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
      return index === 0 ? word.toUpperCase() : word.toLowerCase();
    }).replace(/\s+/g, '');
  }
  const handleNextButtonClick = () => {
    setNextButtonDisabled(true);
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    setErrors({});
    const newErrors = findFormErrors();
    if (Object.keys(newErrors).length > 0) {
      // Scroll to the first error
      const firstErrorKey = Object.keys(newErrors)[0];
      const errorElement = document.getElementsByName(firstErrorKey)[0];
      if (errorElement) {
        errorElement.scrollIntoView({behavior: 'smooth', block: 'center'});
      }
      setErrors(newErrors);
      setNextButtonDisabled(false);

      if (!window.location.hostname.includes('aa')) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'mbiAutosureEvent',
          category: 'Submit',
          status: 'Fail',
          virtualUrl: `${baseUrl}/mbi/step1`,
          pageTitle: 'Car Details',
        });
      }

    } else if (source !== 'LINK' && !errorMessage) {
      const aaMemberData = {
        aaMemberNumber: props.inputValues.aaMembershipNumber,
        lastName: props.inputValues.aaMemberLastName,
        dateOfBirth: props.inputValues.aaMemberDOB
      }

      // Check if AA Member Data is provided
      if (aaMemberData.aaMemberNumber && aaMemberData.lastName && aaMemberData.dateOfBirth) {
        const formattedDOB = moment(aaMemberData.dateOfBirth, 'DD/MM/YYYY').format('YYYY-MM-DD');
        // Make API call to validate membership
        fetch(`${url}/policy-renewal/aa/${aaMemberData.aaMemberNumber}/validate`, {
          method: 'POST',
          mode: "cors",
          headers: {
            'Content-Type': 'application/json',
            "Authorization": 'By-Pass-Auth-Create-Prospect'
          },
          body: JSON.stringify({
            lastName: aaMemberData.lastName,
            dateOfBirth: formattedDOB,
            id: props.inputValues.id
          })
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.discountEligibility === false) {
              // Set error message if membership is not valid
              const newErrors = {}
              newErrors.validMember = "Unfortunately we cannot find your membership, please check your details above.";
              setErrors(newErrors);
              setNextButtonDisabled(false);
            } else {
              amendQuote();
            }
          })
      } else {
        amendQuote();
      }
    } else if (!errorMessage) {
      props.nextStep();
    }
  };
  const amendQuote = () => {
    const aaMemberData = {
      aaMemberNumber: props.inputValues.aaMembershipNumber,
      lastName: props.inputValues.aaMemberLastName,
      dateOfBirth: props.inputValues.aaMemberDOB
    }
    const prospectData = {
      id: props.inputValues.id,
      vehicleValue: props.inputValues.vehicleInputValue.replace(/\$|,/g, ''),
      inceptionKm: props.inputValues.vehicleInputOdometerValue,
      propulsion: props.inputValues.propulsionOptions.toString(),
      exclusions: selectedExclusions.toString(),
      variant: document.querySelector('[name="variantInputValue"]') != null ? document.querySelector('[name="variantInputValue"]').value : null,
      aaMemberData: aaMemberData

    };
    fetch(`${url}/campaign/policy-renewal/prospects`, {
      method: 'PUT', mode: "cors", headers: {
        'Content-Type': 'application/json', "Authorization": 'By-Pass-Auth-Create-Prospect'
      }, body: JSON.stringify(prospectData)
    })
      .then((response) => response.json())
      .then((data) => {
        const isUnderWritingOrNoCover = data.amendQuoteResponse.covers.every(cover =>
          cover.excesses.every(excess => excess.status === "UNDER_WRITING" || excess.status === "NO_COVER")
        );
        if (isUnderWritingOrNoCover) {
          if (!window.location.hostname.includes('aa')) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'mbiAutosureEvent',
              category: 'Submit',
              status: 'Fail',
              virtualUrl: `${baseUrl}/mbi/step1`,
              pageTitle: 'Car Details',
            });
          }
          setContinueOfflinePopupProspectFailed(true);
        } else {
          let coverLength = data.amendQuoteResponse.covers.length;
          props.updateAmendQuoteResponse(JSON.stringify(data.amendQuoteResponse));
          let i = 0
          let jwt = Cookies.get('jwt-token');
          let defaultFound = false;
          let premium = '';
          let searchDefault = true;
          // check if the current selection is still valid
          if (props.inputValues.selectedTermAndCover) {
            for (let cover of data.amendQuoteResponse.covers) {
              if (cover.coverCode === props.inputValues.selectedTermAndCover.coverCode) {
                for (let ex of cover.excesses) {
                  if (ex.excess === props.inputValues.excess &&
                    (ex.status === 'ACTIVE' || ex.status === 'CONDITIONALLY_ACTIVE')) {
                    for (let pr of ex.premiums) {
                      if (pr.term == props.inputValues.selectedTermAndCover.term) {
                        searchDefault = false;
                      }
                    }

                  }
                }
              }
            }
          }
          for (let cover of data.amendQuoteResponse.covers) {
            fetch(`${url}/prospect/quote/additional-benefits?cover=${cover.coverName}&prospectSource=${props.inputValues.source}`, {
              method: "GET",
              mode: "cors",
              headers: new Headers({
                Accept: "application/json",
                "Authorization": `Bearer ${jwt}`
              }),
            })
              .then((response) => response.json())
              .then((data) => {

                i++;
                updateAB(cover.coverName, JSON.stringify(data));

                if (i === coverLength) {
                  props.handleChangeValue("additionalBenefit", new Map(additionalBenefit));

                  if (!window.location.hostname.includes('aa')) {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                      event: 'mbiAutosureEvent',
                      category: 'Submit',
                      status: 'Success',
                      virtualUrl: `${baseUrl}/mbi/step1`,
                      pageTitle: 'Car Details',
                    });
                  }

                  props.nextStep();
                }
              })
              .catch((error) => {
                console.log('Error', error);
              });
          }

        }
      })
      .catch((error) => {
        console.error('API call error:', error);
        setContinueOfflinePopupProspectFailed(true);
      });
  }
  const findFormErrors = () => {
    const newErrors = {}

    if (!props.inputValues.registration || props.inputValues.registration === '') {
      newErrors.registrationNumber = "Please enter registration number"
    } else if (_.isEmpty(props.inputValues.vehicleData)) {
      newErrors.registrationNumber = "Registration number invalid"
    } else if (props.inputValues.vehicleData.registration !== props.inputValues.registration) {
      newErrors.registrationNumber = "Please check registration number"
    }
    if (!props.inputValues.vehicleInputValue || props.inputValues.vehicleInputValue === '') {
      newErrors.vehicleInputValue = "Please enter car's value"
    } else {
      const newValue = props.inputValues.vehicleInputValue.replace(/[^\d]/g, ''); // Remove non-numeric characters
      const numericValue = parseFloat(newValue);
      if (isNaN(numericValue) || numericValue < 3000 || numericValue > 200000) {
        newErrors.vehicleInputValue = "Vehicle value should be between $3,000 and $200,000";
      }
    }
    if (!props.inputValues.vehicleInputOdometerValue || props.inputValues.vehicleInputOdometerValue === '') {
      newErrors.vehicleInputOdometerValue = "Please enter odometer reading"
    } else {
      const newValue = props.inputValues.vehicleInputOdometerValue; // Remove commas for numeric conversion
      // Check if the entered value is numeric
      if (/^\d+$/.test(newValue) || newValue === '' || newValue !== undefined) {
        const numericValue = parseFloat(newValue);
        // Check if the entered value is greater than or equal to vehicleData.odometerReading
        if (vehicleData.odometerReading !== undefined && numericValue < parseFloat(vehicleData.odometerReading.replace(/,/g, ''))) {
          newErrors.vehicleInputOdometerValue = "This must be more than the amount noted on your last Warrant of Fitness.";
        }
      }
    }
    if (!props.inputValues.propulsionOptions || props.inputValues.propulsionOptions.length === 0) {
      newErrors.propulsionOptions = 'Please select the one(s) that apply to your car.'
    }
    if (props.inputValues.exclusions === null || props.inputValues.exclusions === '') {
      newErrors.exclusionsChecked = "Please select ‘Yes’ or ‘No’"
    } else if (props.inputValues.exclusions === 'YES') {
      newErrors.exclusionsChecked = "While we can provide insurance for most cars, we can’t insure this vehicle.";
    }
    if (props.inputValues.isModified === null || props.inputValues.isModified === '') {
      newErrors.isModifiedChecked = "Please select ‘Yes’ or ‘No’"
    } else if (props.inputValues.isModified === 'YES') {
      newErrors.isModifiedChecked = "While we can provide insurance for most cars, we can’t insure this vehicle.";
    }
    if (props.inputValues.existingIssue === null || props.inputValues.existingIssue === '') {
      newErrors.existingIssueChecked = "Please select ‘Yes’ or ‘No’"
    } else if (props.inputValues.existingIssue === 'YES') {
      newErrors.existingIssueChecked = "While we can provide insurance for most cars, we can’t insure this vehicle.";
    }
    if (isAAPath && (props.inputValues.aaMember === null || props.inputValues.aaMember === "")) {
      newErrors.aaMemberChecked = "Please select 'Yes' or 'No'"
    }
    if (isAAPath && props.inputValues.aaMember === 'YES') {
      if (props.inputValues.aaMembershipNumber === null || props.inputValues.aaMembershipNumber === '') {
        newErrors.aaMembershipNumber = "Please enter AA Membership number"
      }
      if (props.inputValues.aaMemberLastName === null || props.inputValues.aaMemberLastName === '') {
        newErrors.aaMemberLastName = "Please enter AA Member last name"
      }
      if (props.inputValues.aaMemberDOB === null || props.inputValues.aaMemberDOB === '') {
        newErrors.aaMemberDOB = "Please enter AA Member date of birth"
      } else {
        let dob = props.inputValues.aaMemberDOB;
        let isValid = moment(dob, 'DD/MM/YYYY', true);
        if (!isValid.isValid()) {
          newErrors.aaMemberDOB = 'Invalid date. Please enter date in format dd/mm/yyyy.'
        }
      }
    }
    if (vehicleData && vehicleData.variant && (!props.inputValues.variant || props.inputValues.variant === '')) {
      newErrors.variant = "Please select car's variant"
    }
    if (Object.keys(newErrors).length > 0) {
      newErrors.titleError = "Please update the highlighted fields below and click 'Next' to get your quote.";
    }
    return newErrors
  }
  useEffect(() => {
    console.log("window.location.href", window.location.href);
    // Track the 'page loaded' event
    if (isAAPath) {
      // Push virtual pageview event to dataLayer for GTM
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'virtualPageview',
        'virtualUrl': '/car_details',
        'pageTitle': 'Car Details'
      });
    }
    if (!window.location.hostname.includes('aa')) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'mbiAutosureEvent',
        category: 'Page View',
        virtualUrl: `${baseUrl}/mbi/step1`,
        pageTitle: 'Car Details',
      });
    }
    if (window.gtag && isAAPath) {
      window.gtag('event', 'Page visited', {
        event_category: 'Page', event_label: 'Car details page',
      });
    }
    scrollToTop();
    setVehicleData(props.inputValues.vehicleData);

    if (props.inputValues.vehicleData.hasOwnProperty("registration")) {
      setVehicleDataPresent(true);
    }
    let token = searchParams.get("token");
    let renewalId = searchParams.get("id");
    var details = {
      'user_id': renewalId, 'password': token,
    };
    if (token == null || props.inputValues.retrieveQuote) {
      // createProspect();
      return;
    }

    var formBody = "?";
    for (var property in details) {
      var encodedKey = encodeURIComponent(property);
      var encodedValue = encodeURIComponent(details[property]);
      formBody += (encodedKey + "=" + encodedValue + '&');
    }
    fetch(url + '/login' + formBody, {

      method: 'POST', mode: "cors", headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      }, body: formBody
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        response.json().then((json) => {
          setCookie('jwt-token', json.JWT, {path: '/'});
          // For QUASHED source, bypass the quote number prompt and directly fetch details
          if (props.inputValues.source === 'QUASHED') {
            setPageLoading(true);
            getVehicleDetails(json.JWT, renewalId, '');
            setReturnUser(false);
            props.handleChangeValue("retrieveQuote", true);
          } else {
            setReturnUser(true);
          }

        });
      })
      .catch((err) => {
        console.error("Caught error: ", err);
        window.location.href = '/turners/page-not-found';  // Update the path as needed
      });

    // Call createProspect if props.inputValues.registration is not blank or null
    if (props.inputValues.registration && props.inputValues.registration.trim() !== '') {
      createProspect();
    }
  }, []);


  function extractParams(inputString) {
    const queryString = inputString.split('?')[1];
    const paramsArray = queryString.split('&');
    const params = {};
    paramsArray.forEach(param => {
      const [key, value] = param.split('=');
      params[key] = value;
    });
    return params;
  }

  const getVehicleDetails = (jwt, renewalId, quotenum) => {
    setErrors({});

    props.handleChangeValue("id", renewalId);

    fetch(url + '/prospect/renewal?renewalId=' + encodeURIComponent(renewalId) + '&quoteNum=' + quoteNum, {

      method: "GET", mode: "cors",
      headers: new Headers({
        Accept: "application/json", "Authorization": `Bearer ${jwt}`
      }),
    }).then((response) => {
      if (!response.ok) {
        const newErrors = {}

        newErrors.quoteNum = "Invalid quote number.";
        setErrors(newErrors);
      } else {
        response.json().then((json) => {
          setReturnUser(false);


          if (json.status === 'CONVERTED') {
            window.location.href = '/mbi/converted';
          } else if (json.status === 'EXPIRED') {
            window.location.href = '/mbi/expired';

          } else {
            if (json.source !== undefined && json.source !== null) {
              props.handleChangeValue("source", json.source);
            }

            if (json.applicant !== undefined) {
              props.handleChangeValue("dateOfBirth", json.applicant.dateOfBirth === undefined || json.applicant.dateOfBirth === null ? '' : json.applicant.dateOfBirth);
              props.handleChangeValue("firstName", json.applicant.firstName === undefined || json.applicant.firstName === null ? '' : json.applicant.firstName);
              props.handleChangeValue("lastName", json.applicant.surname === undefined || json.applicant.surname === null ? '' : json.applicant.surname);
              props.handleChangeValue("applicantType", json.applicant.applicantType === undefined || json.applicant.applicantType === null ? '' : json.applicant.applicantType);
              props.handleChangeValue("businessName", json.applicant.businessName === undefined || json.applicant.businessName === null ? '' : json.applicant.businessName);
              props.handleChangeValue("addressLine1", json.applicant.addressLine1 === undefined || json.applicant.addressLine1 === null ? '' : json.applicant.addressLine1);
              props.handleChangeValue("addressLine2", json.applicant.addressLine2 === undefined || json.applicant.addressLine2 === null ? '' : json.applicant.addressLine2);
              props.handleChangeValue("suburb", json.applicant.suburb === undefined || json.applicant.suburb === null ? '' : json.applicant.suburb);
              props.handleChangeValue("city", json.applicant.city === undefined || json.applicant.city === null ? '' : json.applicant.city);
              props.handleChangeValue("postcode", json.applicant.postcode === undefined || json.applicant.postcode === null ? '' : json.applicant.postcode);
              // this means its not a joint quote
              if (json.applicant.jointDateOfBirth) {
                props.handleChangeValue("joint", true)
                props.handleChangeValue("jointFirstName", json.applicant.jointFirstName);
                props.handleChangeValue("jointLastName", json.applicant.jointSurname);
                props.handleChangeValue("jointDateOfBirth", json.applicant.jointDateOfBirth);
              }
              if (json.applicant.addressLine1) {
                let fullAddress = json.applicant.addressLine1;
                if (json.applicant.addressLine2 !== '') {
                  fullAddress += ', ' + json.applicant.addressLine2;
                }
                fullAddress += ', ' + json.applicant.suburb + ', ' + json.applicant.city + ', ' + json.applicant.postcode
                props.handleChangeValue('full_address', fullAddress);
              }
            }
            if (json.vehicle.vehicleValue !== '3000' || searchParams.get("id") !== null) {
              console.log("here")
              props.handleChangeValue("exclusions", "NO");
              props.handleChangeValue("isModified", "NO");
              props.handleChangeValue("existingIssue", "NO");
              props.handleChangeValue("vehicleInputOdometerValue", json.vehicle.updatedOdometerReading);
              props.handleChangeValue("vehicleInputValue", json.vehicle.vehicleValue);
            }
            props.handleChangeValue("variant", json.vehicle.variantSelected);
            props.handleChangeValue("registration", json.vehicle.registration);


            if (json.vehicle.propulsion !== undefined && json.vehicle.propulsion != null) {
              let propulsionTypes = json.vehicle.propulsion.split(',');

              const updatedPropulsionOptions = [...propulsionTypes];
              props.handleChangeValue("propulsionOptions", updatedPropulsionOptions);
            }


            let coverName;

            setSelectedCover(json);
            // props.handleChangeValue("firstName", json.vehicle.firstName);
            // props.handleChangeValue("lastName", json.vehicle.lastName);
            setVehicleData(json.vehicle);
            props.handleChangeValue("vehicleData", json.vehicle);
            setSource(json.source);
            if (isAAPath) {
              if (json.aaMemberData) {
                props.handleChangeValue("aaMembershipNumber", json.aaMemberData.aaMemberNumber);
                props.handleChangeValue("aaMemberLastName", json.aaMemberData.lastName);
                props.handleChangeValue("aaMemberDOB", json.aaMemberData.dateOfBirth);
                props.handleChangeValue("aaMember", "YES");
              } else if (json.quote.cover != null) {
                props.handleChangeValue("aaMember", "NO");
              }

            }
            setQuoteData(json.quote);
            if (json.applicant !== undefined) {
              props.handleChangeValue("phone", json.applicant.phone);
              props.handleChangeValue("email", json.applicant.email);
            }
            props.inputValues.quote = JSON.stringify(json.quote);
            props.updateBenefits(JSON.stringify(json.additionalbenefits));
            props.updateQuote(JSON.stringify(json.quote));

            // Parse optionalComponents from the response and update state
            if (json.quote && json.quote.optionalComponents) {
              const responseOptionalComponents = json.quote.optionalComponents.split(';');

              // Update state based on response
              props.handleChangeValue('consumables', responseOptionalComponents.includes('ConsumableItems'));
              props.handleChangeValue('aaRoadService', responseOptionalComponents.includes('Roadside'));
              props.handleChangeValue('travelDisruption', responseOptionalComponents.includes('TravelDisruption'));
            } else {
              // If no optionalComponents in response, set all to false
              props.handleChangeValue('consumables', false);
              props.handleChangeValue('aaRoadService', false);
              props.handleChangeValue('travelDisruption', false);
            }

            setVehicleDataPresent(true);
            setPageLoading(false);
            //call amend when all of the above is set
          }
        });
      }
    })
      .catch((err) => {
        console.error("Caught error: ", err);
        setPageLoading(false);
      });
  }

  function setSelectedCover(json) {
    props.handleChangeValue("quoteExpiry", json.quote.expiry);
    if (json.quote.cover === undefined) {
      return;
    }
    console.log("coverCodecoverCode", json)
    let coverCode = json.quote.cover;
    let term = json.quote.term.replace(' months', '');
    let coverName = '';
    if (json.quote.cover === "SmartCover") {
      coverName = "Smart Cover";
    } else if (json.quote.cover === "ExtremePLUS") {
      coverName = "Extreme Plus";
    } else if (json.quote.cover === "T05") {
      coverName = "Assist";
    } else if (json.quote.cover === "T10") {
      coverName = "Assist Plus";
    } else if (json.quote.cover === "ADVANTAGE") {
      coverName = "Advantage";
    } else if (json.quote.cover === "ADVANTAGE_PLUS") {
      coverName = "Advantage Plus";
    }
    props.inputValues.selectedTermAndCover = {
      coverName,
      coverCode,
      term
    };
    props.handleChangeValue("selectedTermAndCover", props.inputValues.selectedTermAndCover);
    if (json.quote !== undefined && json.quote.excess !== undefined && json.quote.excess !== null) {
      props.handleChangeValue("excess", Number(json.quote.excess.replace('$', '')));
    }
  }

  const currencyFormat = (num) => {
    let vv = parseFloat(num);
    return (vv).toLocaleString('en-US', {
      style: 'currency', currency: 'USD',
    }).replace('.00', '');
  }

  const handleInputVehicleValueChange = (e) => {
    const newValue = e.target.value.replace(/[^\d]/g, ''); // Remove non-numeric characters
    const formattedValue = newValue === '' ? '' : currencyFormat(parseFloat(newValue));

    // Update e.target.value with formattedValue
    e.target.value = formattedValue;
    props.handleChangeValue("vehicleInputValue", newValue);
  };
  const handleInputVehicleOdometerChange = (e) => {
    const newValue = e.target.value.replace(/[^\d]/g, ''); // Remove commas for numeric conversion
    // Check if the entered value is numeric
    if (/^\d+$/.test(newValue) || newValue === '') {
      const numericValue = parseFloat(newValue);
      // Check if the entered value is greater than or equal to vehicleData.odometerReading
      // setIsOdometerValid(numericValue >= parseFloat(vehicleData.odometerReading.replace(/,/g, '')));
      const formattedValue = newValue === '' ? '' : parseFloat(newValue).toLocaleString('en-US');
      e.target.value = formattedValue;
      props.handleChangeValue("vehicleInputOdometerValue", numericValue);
    }
  };

  const createProspect = async (e) => {
    if (nztaUnavailable) return;
    setLoading(true);
    const reg = props.inputValues.registration && props.inputValues.registration.trim() !== '' ? props.inputValues.registration : registrationNumber;
    try {
      const response = await fetch(`${apiUrl}/campaign/policy-renewal/vehicleDetails/${reg}`, {
        method: 'GET',
        mode: "cors",
        headers: {
          'Content-Type': 'application/json',
          "Authorization": 'By-Pass-Auth-Create-Prospect'
        }
      });

      let source = '';
      sessionStorage.setItem('source', props.inputValues.source);
      source = props.inputValues.source;

      if (response.ok && response.status === 200) {
        let token = null;

        if (props.inputValues.mbiRecaptchaEnabled) {
          // Execute reCAPTCHA v3
          if (!executeRecaptcha) {
            console.log('reCAPTCHA is not ready');
            setLoading(false);
            return;
          }
          token = await executeRecaptcha('prospect_create');
        }

        const prospectData = {
          email: '',
          mobilePhone: '',
          plate: reg,
          firstName: '',
          lastName: '',
          source: source,
          referrer: "",
          referrerDescription: "",
          recaptchaResponse: token
        };
        try {
          const response = await fetch(`${apiUrl}/campaign/policy-renewal/prospects`, {
            method: 'POST', mode: "cors", headers: {
              'Content-Type': 'application/json', "Authorization": 'By-Pass-Auth-Create-Prospect'
            },
            body: JSON.stringify(prospectData),
          });

          // Handle reCAPTCHA verification failure
          if (response.status === 428) {
            console.log('reCAPTCHA verification failed');
            setLoading(false);
            return;
          }

          if (response.ok) {
            if (response.status === 200) {
              const responseData = await response.json();
              if (responseData.errors.length >= 1) {
                setContinueOfflinePopupShow(true)
              } else {
                setURLSource(responseData.source);
                const params = extractParams(responseData.source);
                let token = params.token;
                let renewalId = params.id;
                var details = {
                  'user_id': renewalId, 'password': token,
                };

                if (token == null) {
                  let jwt = Cookies.get('jwt-token');
                  if (jwt != null) {
                    getVehicleDetails(jwt, renewalId);
                    return;
                  }
                }
                var formBody = "?";
                for (var property in details) {
                  var encodedKey = encodeURIComponent(property);
                  var encodedValue = encodeURIComponent(details[property]);
                  formBody += (encodedKey + "=" + encodedValue + '&');
                }
                fetch(url + '/login' + formBody, {

                  method: 'POST', mode: "cors", headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                  }, body: formBody
                })
                  .then((response) => {
                    if (!response.ok) {
                      throw new Error('Network response was not ok');
                    }
                    response.json().then((json) => {
                      //setCookie('jwt-token', json.jwt, {path: '/'});
                      props.handleChangeValue('sessionTimeout', props.inputValues.sessionTimeout + 1);
                      setCookie('jwt-token', json.JWT, {
                        path: '/',
                        maxAge: props.inputValues.sessionTimeout
                      });
                      getVehicleDetails(json.JWT, renewalId);

                    });
                  })
                  .catch((err) => {
                    console.error("Caught error: ", err);
                    window.location.href = '/turners/page-not-found';  // Update the path as needed
                  });
              }
            }
          } else {
            console.error('Failed to create prospect. Status Code:', response.status);
          }
        } catch (error) {
          console.error('An error occurred:', error);
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.error('Response status:', error.response.status);
            console.error('Response data:', error.response.data);
          } else if (error.request) {
            // The request was made but no response was received
            console.error('No response received:', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('Error setting up the request:', error.message);
          }
          setContinueOfflinePopupShow(true);
        }
      } else {
        const newErrors = {}
        setErrors(newErrors);
        newErrors.registrationNumber = "Please enter a valid plate number";
      }
    } catch (error) {
      console.error('An error occurred:', error);
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.error('Response status:', error.response.status);
        console.error('Response data:', error.response.data);
      } else if (error.request) {
        // The request was made but no response was received
        console.error('No response received:', error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.error('Error setting up the request:', error.message);
      }
      setContinueOfflinePopupShow(true);
    } finally {
      setLoading(false);
    }
  };

  const steps = [// {name: 'Step 1', status: 'complete'},
    {name: 'Step 1', status: 'current', desc: 'Car details'},
    {name: 'Step 2', status: 'upcoming', desc: 'Choose your cover'},
    {name: 'Step 3', status: 'upcoming', desc: 'About you'},
    {name: 'Step 4', status: 'upcoming', desc: 'Pay now'},];
  return (
    <>
      {pageLoading && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999
        }}>
          <Spinner animation="border" style={{
            width: "3rem",
            height: "3rem",
            borderWidth: "4px"
          }}/>
          <p style={{marginTop: '20px', fontSize: '18px', fontWeight: '500'}}>
            Loading your details...
          </p>
        </div>
      )}
      {returnUser ? <WelcomeBackQuote
          quoteNum={quoteNum}
          setQuoteNum={setQuoteNum}
          errors={errors}
          setErrors={setErrors}
          setContinueOfflinePopupProspectFailed={setContinueOfflinePopupProspectFailed}
          handleNewQuoteClick={handleNewQuoteClick}
          isAAPath={isAAPath}
          isVTNZPath={isVTNZPath}
          searchParams={searchParams}
          setSearchParams={setSearchParams}
          url={url}
          props={props}
          setReturnUser={setReturnUser}
          setVehicleData={setVehicleData}
          setSource={setSource}
          setQuoteData={setQuoteData}
          setVehicleDataPresent={setVehicleDataPresent}
        /> :

        <div style={{minHeight: '100vh', display: 'flex', flexDirection: 'column'}}>
          {<><br/>
            <Row className="justify-content-center">
              {isAAPath ? (
                <> <br/><br/>
                  <NavigateAAMBI steps={steps}/> </>
              ) : (
                <NavigateMBI steps={steps}/>
              )}
            </Row>
            <br/>
            <Container className="lg-carQuote-padding container-padding" style={{flex: 1}}>
              <Form.Group>
                <div className="subHeadingStyles">Car Details</div>
              </Form.Group>
              <br/>
              {errors.titleError && (
                <>
                  <div className="regularErrorStyle">{errors.titleError}</div>
                  <br/>
                </>
              )}
              <div className="column-on-mobile lg-style" style={{display: 'flex', paddingBottom: '19px'}}>
                {isAAPath ? (
                  <MidBlueCarIcon/>
                ) : (
                  <BlackCarIcon/>
                )}
                <div className='lg-margin-left-19'>
                  <div className="regularTextStyles">
                    Enter your car’s number plate
                  </div>
                  <div style={{display: "flex", gap: "10px"}}>
                    <input
                      type="text"
                      placeholder="MYREGO"
                      name="registrationNumber"
                      style={{
                        width: '170px',
                        boxShadow: '0px 1px 2px rgba(60, 66, 80, 0.05)',
                        border: '1px #E5E7EB solid',
                        fontSize: 22,
                        alignContent: "center",
                        textAlign: "center",
                        backgroundImage: `url(${regobg})`,
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        backgroundSize: "10rem"

                      }}
                      maxLength={6}
                      autoCorrect="off"
                      autoComplete="off"
                      className="block w-full rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      defaultValue={props.inputValues.registration}
                      onChange={(event) => {
                        event.target.value = event.target.value.toUpperCase();
                        handleRegistrationNumberChange(event);
                      }}
                      required={true}
                      onFocus={() => setIsFocused(true)}
                      onBlur={(event) => {
                        setNextButtonDisabled(false);
                        const trimmedValue = event.target.value.trim();
                        if (trimmedValue !== '') {
                          createProspect();
                        }
                      }}
                    />
                    <div>
                      {loading && <><Spinner animation="border" style={{
                        width: "1rem", // Set the same value for width and height to make it a circle
                        height: "1rem",
                        borderWidth: "2px",
                        borderRadius: "50%", // Ensure it's round
                        fontWeight: "normal !important",
                        marginTop: "10px"
                      }}
                      />
                      </>}</div>
                  </div>
                  {errors.registrationNumber && !nztaUnavailable && (
                    <div className="regularErrorStyle">{errors.registrationNumber}</div>
                  )}
                  {nztaUnavailable && (registrationNumber || props.inputValues.registration) && (
                    <div className="regularErrorStyle">The NZTA service is temporarily unavailable, so we cannot search for your vehicle. Please try again later. Thank you for your patience.</div>
                  )}
                </div>
              </div>
              {!vehicleDataPresent ? <></> : <>
                {/*{vehicleDataPresent &&*/}
                <div style={{display: 'flex', flexDirection: 'column'}}>
                  {/* First Row */}
                  <div className='column-on-mobile margin-bottom-10' style={{display: 'flex'}}>
                    <div style={{display: 'flex', flex: 1, marginBottom: '10px'}}>
                      <div style={{width: "150px"}}> <span
                        className="regularTextStyles">
                                        Registration
                                  </span></div>

                      <div> <span className="regularBlueTextStyles regularOrangeTextStyles">
                                        {vehicleData.registration}
                                    </span></div>

                    </div>
                    <div style={{display: 'flex', flex: 1, marginBottom: '10px'}}>
                      <div style={{width: "150px"}}>   <span className="regularTextStyles">
                                        Year
                                    </span></div>

                      <div>  <span className="regularBlueTextStyles regularOrangeTextStyles">
                                        {vehicleData.year}
                                 </span></div>
                    </div>
                  </div>
                  {/* Second Row */}
                  <div className='column-on-mobile margin-bottom-10' style={{display: 'flex'}}>
                    <div style={{display: 'flex', flex: 1, marginBottom: '10px'}}>
                      <div style={{width: "150px"}}> <span className="regularTextStyles">
                                    Make
                                </span></div>
                      <div><span className="regularBlueTextStyles regularOrangeTextStyles">
                                    {camelize(vehicleData.make)}
                                </span></div>
                    </div>
                    <div style={{display: 'flex', flex: 1, marginBottom: '10px'}}>
                      <div style={{width: "150px"}}> <span className="regularTextStyles">
                                Model
                            </span></div>
                      <div> <span className="regularBlueTextStyles regularOrangeTextStyles">
                                {camelize(vehicleData.model)}
                            </span></div>
                    </div>
                  </div>

                  {/* Third Row */}
                  <div className='column-on-mobile margin-bottom-10 ' style={{display: 'flex'}}>
                    <div style={{display: 'flex', flex: 1, marginBottom: '10px'}}>
                      <div style={{width: "150px"}}><span className="regularTextStyles">
                                Fuel
                            </span></div>
                      <div> <span className="regularBlueTextStyles regularOrangeTextStyles">
                                {vehicleData.fuelType}
                            </span></div>
                    </div>
                    <div style={{display: 'flex', flex: 1, marginBottom: '10px'}}>
                      <div style={{width: "150px"}}>  <span className="regularTextStyles">
                                CC rating
                                 <TooltipTFAF
                                   placement="top"
                                   title="This is the car’s engine capacity in cubic centimeters (cc)."
                                 >
                                    <i className="fa fa-info-circle"/>
                                </TooltipTFAF>
                            </span></div>
                      <div>  <span className="regularBlueTextStyles regularOrangeTextStyles">
                                {vehicleData.ccRating}
                            </span></div>
                    </div>
                  </div>
                </div>
              </>}

              {/* Fourth Row */}
              <div className='column-on-mobile margin-bottom-10' style={{display: 'flex'}}>
                <div style={{display: 'flex', flex: 1, marginBottom: '10px'}}>
                  <div style={{width: "150px"}}> <span className="regularTextStyles">
                                Car's value
                                <TooltipTFAF
                                  placement="top"
                                  title="The current retail value of your car. You can find this out by looking at cars for sale online that are the same make, model, year, condition and mileage as yours."
                                >
                                    <i className="fa fa-info-circle"/>
                                </TooltipTFAF>
                            </span></div>
                  <div>   <span className="regularBlueTextStyles">
                                <input
                                  type={"tel"}
                                  className="block w-full rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                  style={{
                                    width: '170px',
                                    boxShadow: '0px 1px 2px rgba(60, 66, 80, 0.05)',
                                    border: '1px #E5E7EB solid',
                                  }}
                                  name="vehicleInputValue"
                                  maxLength={8}
                                  required={true}
                                  placeholder="e.g. $10,000"
                                  defaultValue={props.inputValues.vehicleInputValue ? currencyFormat(props.inputValues.vehicleInputValue) : ''}
                                  onChange={(e) => {
                                    handleInputVehicleValueChange(e);
                                  }}
                                />
                            </span>{errors.vehicleInputValue && (
                    <div className="regularErrorStyle">{errors.vehicleInputValue}</div>
                  )}</div>
                </div>
                <div style={{display: 'flex', flex: 1, marginBottom: '10px'}}>
                  <div style={{width: "150px"}}>  <span className="regularTextStyles">
                                Odometer (km)
                                <TooltipTFAF
                                  placement="top"
                                  title="The current total distance your car has travelled (known as ‘mileage’). You can find this on your car’s dashboard.This will be more than the amount noted on your last Warrant of Fitness."
                                >
                                    <i className="fa fa-info-circle"/>
                                </TooltipTFAF>
                            </span></div>
                  <div> <span className="regularBlueTextStyles">
                                <input
                                  type={"tel"}
                                  className="block w-full rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                  style={{
                                    width: '170px',
                                    boxShadow: '0px 1px 2px rgba(60, 66, 80, 0.05)',
                                    border: '1px #E5E7EB solid',
                                  }}
                                  name="vehicleInputOdometerValue"
                                  maxLength={7}
                                  required={true}
                                  placeholder="e.g. 80,000"
                                  defaultValue={props.inputValues.vehicleInputOdometerValue ? parseFloat(props.inputValues.vehicleInputOdometerValue).toLocaleString('en-US') : ''}
                                  onChange={(e) => {
                                    handleInputVehicleOdometerChange(e);
                                  }}
                                />
                            </span>
                    {errors.vehicleInputOdometerValue && (
                      <div className="regularErrorStyle">{errors.vehicleInputOdometerValue}</div>
                    )}
                  </div>
                </div>
              </div>
              {/*Fifth row*/}
              {vehicleData && vehicleData.variant && (
                <div className='column-on-mobile' style={{display: 'flex', marginBottom: '10px'}}>
                  <div style={{display: 'flex', flex: 1, marginBottom: '10px'}}>
                    <div style={{width: "150px"}}> <span className="regularTextStyles">
                                        Variant
                                    </span>
                    </div>
                    <div>
                                            <span className="regularBlueTextStyles">
                                               <select
                                                 className="block w-full rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                                 style={{
                                                   width: '170px',
                                                   boxShadow: '0px 1px 2px rgba(60, 66, 80, 0.05)',
                                                   border: '1px #E5E7EB solid',
                                                 }}
                                                 name="variantInputValue"
                                                 required={true}
                                                 value={props.inputValues.variant || ''} // Set the selected value
                                                 onChange={(e) => {
                                                   setNextButtonDisabled(false);
                                                   props.handleChangeValue('variant', e.target.value)
                                                 } // Save the selected value
                                                 }
                                               >
                                                 <option value="" disabled selected>Please select</option>
                                                 {vehicleData.variant
                                                   ? vehicleData.variant.split(';').map((variant, index) => (
                                                     <option key={index} value={variant}>
                                                       {variant}
                                                     </option>
                                                   ))
                                                   : null}
                                                  </select>
                                    </span>
                      {errors.variant && (
                        <div className="regularErrorStyle">{errors.variant}</div>
                      )}
                    </div>
                  </div>
                  <div style={{display: 'flex', flex: 1, marginBottom: '10px'}}>
                    <div style={{flex: 1}}></div>
                    <div style={{flex: 1}}></div>
                  </div>
                </div>)
              }


              <ContinueOfflinePopupTFAF2
                parentContinueOfflinePopupShow={continueOfflinePopupShow}
                setParentContinueOfflinePopupShow={setContinueOfflinePopupShow}
                parentModificationText={props.inputValues.modification}
              />
              <ContinueOfflinePopupProspectFailed
                parentContinueOfflinePopupShow={continueOfflinePopupProspectFailed}
                setParentContinueOfflinePopupShow={setContinueOfflinePopupProspectFailed}
              />
              {errorMessage && (<div className="text-danger">{errorMessage}</div>)}
              <br/>
              <span className="text-font-label boldTextStyles">Do any of these apply to your car?</span>
              &nbsp;
              <br/>
              <FormGroup>
                <Row className="regularTextStyles">
                  <Col sm="2" style={{paddingTop: '9px', paddingBottom: '9px'}}>
                    <Form.Check
                      type="checkbox"
                      id="propulsion-electric"
                      label="Electric"
                      onChange={() => handlePropulsionChange('ELECTRIC')}
                      checked={props.inputValues.propulsionOptions.includes('ELECTRIC')}
                    />
                  </Col>
                  <Col sm="2" style={{paddingTop: '9px', paddingBottom: '9px'}}>
                    <Form.Check
                      type="checkbox"
                      id="propulsion-hybrid"
                      label="Hybrid"
                      onChange={() => handlePropulsionChange('HYBRID')}
                      checked={props.inputValues.propulsionOptions.includes('HYBRID')}
                    />
                  </Col>
                  <Col sm="6" style={{paddingTop: '9px', paddingBottom: '9px'}}>

                    <Form.Check
                      type="checkbox"
                      id="propulsion-turbo-supercharged"

                    >
                      <Form.Check.Input type="checkbox"
                                        onChange={() => handlePropulsionChange('TURBO_SUPERCHARGED_OR_ROTARY')}
                                        checked={props.inputValues.propulsionOptions.includes('TURBO_SUPERCHARGED_OR_ROTARY')}/>
                      <Form.Check.Label>
                        Turbo/supercharged or rotary
                      </Form.Check.Label>
                      <TooltipTFAF
                        placement="top"
                        title={<span>The badge on the back of your car may have:<ul><li>"Turbo" or "T" if its turbo</li><li>"Supercharged" or "SC" if its supercharged</li><li>"Rotary" or "Wankel" if its rotary</li></ul></span>}
                      >
                        <i className="fa fa-info-circle"/>
                      </TooltipTFAF>
                    </Form.Check>

                  </Col>
                </Row>
                <Row>
                  <Col style={{paddingTop: '9px', paddingBottom: '9px', fontStyle: 'italic'}}>
                    <Form.Check
                      type="checkbox"
                      id="propulsion-none"
                      label="None of the above"
                      className="regularTextStyles"
                      onChange={() => handlePropulsionChange('None of the above')}
                      checked={props.inputValues.propulsionOptions.includes('None of the above')}
                    />
                  </Col>
                </Row>
                {errors.propulsionOptions && (
                  <div className="regularErrorStyle">{errors.propulsionOptions}</div>
                )}
              </FormGroup>
              <br/>
              <div className="text-font-label boldTextStyles">
                Does your car have any existing or previous issues that have not been repaired?
                <TooltipTFAF
                  placement="top"
                  title="This insurance does not cover any fault or issue that existed prior to the start your period of insurance or any resulting damage."
                >
                  <i className="fa fa-info-circle"/>
                </TooltipTFAF>
              </div>
              <p style={{marginTop: "15px", display: "flex", alignItems: "center"}}>
                <Form.Check
                  type="radio"
                  label="Yes"
                  className="regularTextStyles"
                  id="existingIssueYes"
                  checked={props.inputValues.existingIssue === 'YES'}
                  onChange={() => {
                    setContinueOfflinePopupShow(true);
                    props.handleChangeValue("existingIssue", "YES");
                  }}
                />
                &emsp;&emsp;&emsp;&emsp;
                <Form.Check
                  type="radio"
                  label="No"
                  className="regularTextStyles"
                  id="existingIssueNo"
                  checked={props.inputValues.existingIssue === 'NO'}
                  onChange={() => {
                    setContinueOfflinePopupShow(false);
                    props.handleChangeValue("existingIssue", "NO");
                  }}
                />
              </p>
              {errors.existingIssueChecked && (
                <div className="regularErrorStyle">{errors.existingIssueChecked}</div>
              )}
              <br/>
              <div className="text-font-label boldTextStyles">
                Has your car been modified?
                <TooltipTFAF
                  placement="top"
                  title="Since your car was manufactured, has anything been added or changed that is different from the original manufacturer's specifications? Examples of this are suspension changes, aftermarket fitted turbo or modified engine management systems."
                >
                  <i className="fa fa-info-circle"/>
                </TooltipTFAF>
              </div>
              <p style={{marginTop: "15px", display: "flex", alignItems: "center"}}>
                <Form.Check
                  type="radio"
                  label="Yes"
                  className="regularTextStyles"
                  id="modificationYes"
                  checked={props.inputValues.isModified === 'YES'}
                  onChange={() => {
                    setContinueOfflinePopupShow(true);
                    props.handleChangeValue("isModified", "YES");
                  }}
                />
                &emsp;&emsp;&emsp;&emsp;
                <Form.Check
                  type="radio"
                  label="No"
                  className="regularTextStyles"
                  id="modificationNo"
                  checked={props.inputValues.isModified === 'NO'}
                  onChange={() => {
                    setContinueOfflinePopupShow(false);
                    props.handleChangeValue("isModified", "NO");
                  }}
                />
              </p>
              {errors.isModifiedChecked && (
                <div className="regularErrorStyle">{errors.isModifiedChecked}</div>
              )}
              <br/>
              <div className="text-font-label boldTextStyles">
                While we can provide insurance for most cars, in some situations we can't provide cover. Do any of these
                apply?
              </div>

              <div style={{paddingTop: '16px'}}>
                <ul className="regularTextStyles">
                  {/*commented out because business wants there specific points*/}
                  {/* {exclusions.map((exclusion) => (
                            <li key={exclusion.description}>
                                {exclusion.description}
                            </li>
                        ))}*/}
                  <li>Cars without a current Warrant of Fitness or Registration.</li>
                  <li>Cars used for commercially carrying passengers e.g. Uber or taxi, delivery of
                    goods e.g.
                    courier, for driver instruction, or for competitive purposes, racing, testing or
                    off-road
                    activity
                  </li>
                  <li>Cars that have been flooded, water or fire damaged, or written off
                  </li>
                  <li>Cars that are left hand drive, over 3,500kg gross vehicle mass (GVM) or are
                    powered by
                    an
                    engine with more than 8 cylinders
                  </li>
                  <li>Motorcycles, all-terrain vehicles (ATVs) or quad bikes, custom / homebuilt / replica or restored
                    cars,
                    dune
                    buggies,
                    kit cars, classic, vintage or emergency vehicles
                  </li>
                </ul>
              </div>
              <p style={{marginTop: "15px", display: "flex", alignItems: "center"}}>
                <Form.Check
                  type="radio"
                  label="Yes"
                  className="regularTextStyles"
                  id="exclusionsYes"
                  checked={props.inputValues.exclusions === 'YES'}
                  onChange={() => {
                    setContinueOfflinePopupShow(true);
                    props.handleChangeValue("exclusions", "YES");
                  }}
                />
                &emsp;&emsp;&emsp;&emsp;
                <Form.Check
                  type="radio"
                  label="No"
                  className="regularTextStyles"
                  id="exclusionsNo"
                  checked={props.inputValues.exclusions === 'NO'}
                  onChange={() => {
                    setContinueOfflinePopupShow(false);
                    props.handleChangeValue("exclusions", "NO");
                  }}
                />
              </p>
              {errors.exclusionsChecked && (
                <div className="regularErrorStyle">{errors.exclusionsChecked}</div>
              )}
              {isAAPath && (
                <>
                  <div className="text-font-label boldTextStyles" style={{paddingTop: '16px'}}>
                    Are you an AA Member?
                    <TooltipTFAF
                      placement="top"
                      title="A 10% AA Member discount is available if you provide a valid AA Membership number for you or someone named on your policy."
                    >
                      <i className="fa fa-info-circle"/>
                    </TooltipTFAF>
                  </div>
                  <p style={{marginTop: "15px", display: "flex", alignItems: "center"}}>
                    <Form.Check
                      type="radio"
                      label="Yes"
                      className="regularTextStyles"
                      id="AAmemberYes"
                      checked={props.inputValues.aaMember === 'YES'}
                      onChange={() => {
                        props.handleChangeValue("aaMember", "YES");
                      }}
                    />
                    &emsp;&emsp;&emsp;&emsp;
                    <Form.Check
                      type="radio"
                      label="No"
                      className="regularTextStyles"
                      id="AAmemberNo"
                      checked={props.inputValues.aaMember === 'NO'}
                      onChange={() => {
                        props.handleChangeValue("aaMember", "NO");
                        props.handleChangeValue("aaMembershipNumber", "");
                        props.handleChangeValue("aaMemberLastName", "");
                        props.handleChangeValue("aaMemberDOB", "");
                      }}
                    />
                  </p>
                  {errors.aaMemberChecked && (
                    <div className="regularErrorStyle">{errors.aaMemberChecked}</div>
                  )}
                  {props.inputValues.aaMember === 'YES' && (
                    <>

                      <div className="text-font-label boldTextStyles"
                           style={{paddingTop: '16px'}}>
                        What's your AA Membership number?
                      </div>
                      <span className="regularBlueTextStyles">
                                <input
                                  type="text"
                                  inputMode="numeric"
                                  className="block w-full rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                  style={{
                                    width: '170px',
                                    boxShadow: '0px 1px 2px rgba(60, 66, 80, 0.05)',
                                    border: '1px #E5E7EB solid',
                                  }}
                                  name="aaMembershipNumber"
                                  maxLength="16"
                                  defaultValue={props.inputValues.aaMembershipNumber}
                                  onChange={(e) => {
                                    props.handleChangeValue("aaMembershipNumber", e.target.value);
                                  }}
                                  onInput={(e) => {e.target.value = e.target.value.replace(/[^0-9]/g, '');}}
                                />
                            </span>
                      {errors.aaMembershipNumber && (
                        <div className="regularErrorStyle">{errors.aaMembershipNumber}</div>)}
                      <div className='column-on-mobile text-font-label'
                           style={{display: 'flex', marginBottom: '10px', paddingTop: '31px'}}>
                        <div style={{display: 'flex', flex: 1, marginBottom: '10px'}}>
                          <div className="boldTextStyles">
                            AA Member last name
                          </div>
                          &nbsp;&nbsp;
                          <div>   <span className="regularBlueTextStyles">
                                <input
                                  type="text"
                                  className="block w-full rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                  style={{
                                    width: '170px',
                                    boxShadow: '0px 1px 2px rgba(60, 66, 80, 0.05)',
                                    border: '1px #E5E7EB solid',
                                  }}
                                  name="aaMemberLastName"
                                  maxLength={50}
                                  defaultValue={props.inputValues.aaMemberLastName}
                                  onChange={(e) => {
                                    props.handleChangeValue("aaMemberLastName", e.target.value);
                                  }}
                                />
                            </span>
                            {errors.aaMemberLastName && (
                              <div
                                className="regularErrorStyle">{errors.aaMemberLastName}</div>)}
                          </div>

                        </div>

                        <div style={{display: 'flex', flex: 1, marginBottom: '10px'}}>
                          <div className="boldTextStyles">
                            AA Member date of birth

                          </div>
                          &nbsp;&nbsp;
                          <div> <span className="regularBlueTextStyles">
                                <input
                                  type="text"
                                  className="block w-full rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                  style={{
                                    width: '170px',
                                    boxShadow: '0px 1px 2px rgba(60, 66, 80, 0.05)',
                                    border: '1px #E5E7EB solid',
                                  }}
                                  name="aaMemberDOB"
                                  placeholder="dd/mm/yyyy"
                                  value={props.inputValues.aaMemberDOB || ""}
                                  onChange={(e) => {
                                    let inputVal = e.target.value;
                                    const prevValue = e.target.getAttribute('data-prev') || "";

                                    // Remove all non-digit characters to get raw digits
                                    let digits = inputVal.replace(/\D/g, '');

                                    // Limit to 8 digits (DDMMYYYY)
                                    if (digits.length > 8) {
                                      digits = digits.slice(0, 8);
                                    }

                                    // Format digits into DD/MM/YYYY
                                    let formatted = '';
                                    if (digits.length > 0) formatted += digits.slice(0, 2);
                                    if (digits.length >= 3) formatted += '/' + digits.slice(2, 4);
                                    if (digits.length >= 5) formatted += '/' + digits.slice(4, 8);

                                    // Detect if user is deleting
                                    const isDeleting = prevValue.length > inputVal.length;

                                    // If deleting, keep raw input temporarily
                                    if (isDeleting) {
                                      formatted = inputVal;
                                    }

                                    // Store current value for comparison in next change
                                    e.target.setAttribute('data-prev', formatted);

                                    // Send formatted value to handler
                                    props.handleChangeValue("aaMemberDOB", formatted);
                                  }}
                                />
                            </span>
                            {errors.aaMemberDOB && (
                              <div
                                className="regularErrorStyle">{errors.aaMemberDOB}</div>)}
                          </div>
                        </div>
                      </div>
                      {errors.validMember && (
                        <div className="regularErrorStyle">{errors.validMember}</div>
                      )}
                    </>
                  )
                  }
                </>
              )}
              <br/><br/>
              <p
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: "center",
                  paddingTop: '10px'
                }}>
                <button
                  className="float-end"
                  onClick={() => props.prevStep()}
                  style={{
                    color: isVTNZPath ? '#E87722' : isAAPath ? '#0d59bf' : '#1851a3',
                    paddingLeft: 25,
                    paddingRight: 25,
                    paddingTop: 13,
                    paddingBottom: 13,
                    background: 'white',
                    border: isVTNZPath ? '1px #E87722 solid' : '1px #1851a3 solid',
                    justifyContent: 'center',
                    alignItems: 'center',
                    display: 'inline-flex',
                    wordWrap: 'break-word',
                    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
                    borderRadius: isAAPath || isVTNZPath ? 30 : 6,
                    width: "100%",
                    maxWidth: "200px"
                  }}
                >
                  Back
                </button>

                <button className="float-end"

                        onClick={handleNextButtonClick}
                        disabled={nextButtonDisabled || !props.inputValues.vehicleData.hasOwnProperty("vin")}
                        style={{
                          color: 'white',
                          boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
                          borderRadius: isAAPath || isVTNZPath ? 30 : 6,
                          paddingLeft: 25,
                          paddingRight: 25,
                          paddingTop: 13,
                          paddingBottom: 13,
                          overflow: 'hidden',
                          border: isVTNZPath ? '1px #E87722 solid' : isAAPath ? '1px #0d59bf solid' : '1px #1851a3 solid',
                          justifyContent: 'center',
                          alignItems: 'center',
                          display: 'inline-flex',
                          width: "100%",
                          maxWidth: "200px",
                          background: nextButtonDisabled || !props.inputValues.vehicleData.hasOwnProperty("vin") ? (isVTNZPath ? '#f7e1d0' : '#B0C4DE') : isVTNZPath ? '#E87722' : isAAPath
                            ? '#0d59bf'
                            : '#1851a3',
                          cursor: nextButtonDisabled || !props.inputValues.vehicleData.hasOwnProperty("vin") ? 'not-allowed' : 'pointer',

                        }}
                >
                  Next
                </button>
              </p>
              <br/>
              <br/>

              <br/>
              <br/>
              <br/>
              <br/>
            </Container>
          </>
          }
        </div>
      }
      {/*<RecaptchaPopup*/}
      {/*  inputValues={props.inputValues}*/}
      {/*  handleChangeValue={props.handleChangeValue}*/}
      {/*/>*/}
    </>
  );
}

export default CarDetailsTFAF;
